import { WorkLog } from 'domain/entities/Worklog';

export const getLastWorkLog = (workLogs: WorkLog[]) => {
  return workLogs.length > 0
    ? workLogs.reduce((acc, curr) =>
        acc.startedAt.getTime() > curr.startedAt.getTime() ? acc : curr,
      )
    : undefined;
};
